import { render, staticRenderFns } from "./GameMoQuDetail.vue?vue&type=template&id=3d4f14c0&scoped=true"
import script from "./GameMoQuDetail.vue?vue&type=script&lang=js"
export * from "./GameMoQuDetail.vue?vue&type=script&lang=js"
import style0 from "./GameMoQuDetail.vue?vue&type=style&index=0&id=3d4f14c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f14c0",
  null
  
)

export default component.exports